import {
  Box,
  Button,
  List,
  ListItem,
  Menu,
  TextField,
  Typography,
  alpha,
  styled,
} from '@mui/material';
import { lightPalette, up } from '../../../../theme';

export const classes = {
  root: 'root',
  HeaderMoreVertIcon: 'HeaderMoreVertIcon',
  ColumnSelectionBox: 'ColumnSelectionBox',
  ExternalHeaderCheckbox: 'ExternalHeaderCheckbox',
  ExternalHeaderTitle: 'ExternalHeaderTitle',
  MonthSelectDropdownButton: 'MonthSelectDropdownButton',
  MonthSelectDropdownButtonMenu: 'MonthSelectDropdownButtonMenu',
  SearchField: 'SearchField',
  externalHeaderAppBar: 'externalHeaderAppBar',
  externalHeaderAppBarTransaction: 'externalHeaderAppBarTransaction',
  FilterBySelectDropdownButton: 'FilterBySelectDropdownButton',
  documentRowMainBox: 'documentRowMainBox',
  documentNameBox: 'documentNameBox',
  selectOptionsMainBox: 'selectOptionsMainBox',
  SelectedOptionsInnerBox: 'SelectedOptionsInnerBox',
  editIconBox: 'editIconBox',
  editIcon: 'editIcon',
  StatusIcon: 'StatusIcon',
  StatusIconSize: 'StatusIconSize',
  TagChip: 'TagChip',
  actionIcons: 'actionIcons',
  moreVertIconBadge: 'moreVertIconBadge',
  responsiveHeaderBox: 'responsiveHeaderBox',
  selectedDocumentBox: 'selectedDocumentBox',
  documentSelectedTypo: 'documentSelectedTypo',
  documentRowTypography: 'documentRowTypography',
  documentRowTypographyColor: 'documentRowTypographyColor',
  documentEditCellBox: 'documentEditCellBox',
  editCellTextfield: 'editCellTextfield',
  editCellActionIcons: 'editCellActionIcons',
  failedChipColor: 'failedChipColor',
  completedChipColor: 'completedChipColor',
  inProgressChipColor: 'inProgressChipColor',
  pendingChipColor: 'pendingChipColor',
  tagChip: 'tagChip',
  dateValueBox: 'dateValueBox',
  actionBox: 'actionBox',
  selectOptionsMainBoxSecond: 'selectOptionsMainBoxSecond',
  selectedVersionBox: 'selectedVersionBox',
  loaderBox: 'loaderBox',
  justifyContentFlexEnd: 'justifyContentFlexEnd',
  menuIconColor: 'menuIconColor',
  gridBox: 'gridBox',
  allReadButton: 'allReadButton',
  customFilterMainBox: 'customFilterMainBox',
  customFilterButtonBox: 'customFilterButtonBox',
  customFilterButtonClass: 'customFilterButtonClass',
  addOrganizationsButton: 'addOrganizationsButton',
  resetButtons: 'resetButtons',
  svgIconsSize: 'svgIconsSize',
  addMoreButton: 'addMoreButton',
  accuracySelectionDropdown: 'accuracySelectionDropdown',
  gridBoxTransactions: 'gridBoxTransactions',
  TransactionHeight: 'TransactionHeight',
};

export const CurserPointerBox = styled(Box)(() => ({
  cursor: 'pointer',
}));

export const SelectColumnMenu = styled(Menu)(() => ({
  height: '45vh',
  position: 'absolute',
  top: '2%',
  left: '-0.4%',
}));

export const MonthMenu = styled(Menu)(() => ({
  top: '0.5%',
  '& .MuiPaper-root': {
    [up('xs')]: {
      width: '100px',
    },
    [up('sm')]: {
      width: '82px',
    },
    [up('md')]: {
      width: '87px',
    },
    [up('lg')]: {
      width: '95px',
    },
    [up('xl')]: {
      width: '106px',
    },
    [up('xxl')]: {
      width: '109x',
    },
  },
}));
export const StyledMenu = styled(Menu)(({ theme }) => ({
  top: '2%',
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: 'rgb(55, 65, 81)',
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '0px',
    },
    '& .MuiList-root': {
      padding: '0px',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
    ...theme.applyStyles('dark', {
      color: theme.palette.grey[300],
    }),
  },
}));
export const PaperComponentBox = styled(Box)(({ theme }) => ({
  background: theme.palette.secondaryWhite.main,
}));
export const CustomFilterBox = styled(Box)(({ theme }) => ({
  background: theme.palette.secondaryWhite.main,
  overflowY: 'auto',
  maxHeight: '400px',
  height: '100%',
}));
export const AutoCompleteRenderListTypography = styled(Typography)(() => ({
  overflowWrap: 'anywhere',
}));
export const SelectedFilterTypo = styled(Typography)(() => ({
  color: 'rgba(0, 0, 0, 0.6)',
}));

export const CancelButton = styled(Button)(() => ({
  backgroundColor: lightPalette.paperWhite.main,
  color: lightPalette.lunarBase.main,
}));
export const ListItemsHeader = styled(ListItem)(() => ({
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  borderRadius: '5px',
  cursor: 'pointer',
  [up('xs')]: {
    padding: '4px 8px',
    marginBottom: '4px',
  },
}));

export const ListElement = styled(List)(() => ({
  maxHeight: '400px',
  overflow: 'auto',
}));
export const FilterTextField = styled(TextField)(() => ({
  paddingRight: '10px',
}));
export const FilterBox = styled(Box)(() => ({
  maxHeight: '305px',
  overflow: 'auto',
  '&::-webkit-scrollbar': {
    width: '0.4em',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#888', // Scrollbar thumb color
    borderRadius: '5px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#555', // Thumb hover color
    borderRadius: '5px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent', // Track color
    borderRadius: '5px',
  },
  scrollbarWidth: 'thin', // For Firefox
  scrollbarColor: '#888 transparent', // For Firefox
}));

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    height: '100%',
  },
  [`& .${classes.HeaderMoreVertIcon}`]: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  [`& .${classes.ColumnSelectionBox}`]: {
    position: 'absolute',
    zIndex: 1000,
    top: '12px',
    right: '0px',
  },

  [`& .${classes.ExternalHeaderCheckbox}`]: {
    [up('xs')]: {
      marginRight: '50px',
    },
    [up('sm')]: {
      marginRight: '47px',
    },
    [up('md')]: {
      marginRight: '47px',
    },
    [up('lg')]: {
      marginRight: '43px',
    },
    [up('xl')]: {
      marginRight: '39px',
    },
    [up('xxl')]: {
      marginRight: '35px',
    },
  },
  [`& .${classes.ExternalHeaderTitle}`]: {
    // flexGrow: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: theme.palette.darkPurple.main,
    [up('xs')]: {
      display: 'none',
    },
    [up('sm')]: {
      display: 'block',
    },
  },
  [`& .${classes.TransactionHeight}`]: {
    height: '100%',
  },
  [`& .${classes.addMoreButton}`]: {
    marginRight: 0,
    marginLeft: 0,
    [up('xs')]: {
      width: '100px',
      height: '25px',
    },
    [up('sm')]: {
      width: '120px',
      height: '28px',
    },
    [up('md')]: {
      width: '120px',
      height: '30px',
    },
    [up('lg')]: {
      width: '130px',
      height: '33px',
    },
    [up('xl')]: {
      width: '140px',
      height: '35px',
    },
    [up('xxl')]: {
      width: '170px',
      height: '42px',
    },
  },
  [`& .${classes.svgIconsSize}`]: {
    [up('xs')]: {
      width: '12px',
      height: '12px',
    },
    [up('sm')]: {
      width: '12px',
      height: '12px',
    },
    [up('md')]: {
      width: '14px',
      height: '14px',
    },
    [up('lg')]: {
      width: '16px',
      height: '16px',
    },
    [up('xl')]: {
      width: '18px',
      height: '18px',
    },
    [up('xxl')]: {
      width: '20px',
      height: '20px',
    },
  },
  [`& .${classes.addOrganizationsButton}`]: {
    [up('xs')]: {
      width: '130px',
      height: '25px',
    },
    [up('sm')]: {
      width: '140px',
      height: '28px',
    },
    [up('md')]: {
      width: '140px',
      height: '30px',
    },
    [up('lg')]: {
      width: '150px',
      height: '33px',
    },
    [up('xl')]: {
      width: '170px',
      height: '35px',
    },
    [up('xxl')]: {
      width: '200px',
      height: '45px',
    },
  },
  [`& .${classes.MonthSelectDropdownButton}`]: {
    background: theme.palette.secondaryWhite.semiDark,
    color: theme.palette.darkPurple.darker,
    ':hover': {
      background: theme.palette.secondaryWhite.semiDark,
      color: theme.palette.darkPurple.darker,
    },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [up('xs')]: {
      width: '100px',
      height: '20px',
    },
    [up('sm')]: {
      width: '82px',
      height: '25px',
    },
    [up('md')]: {
      width: '87px',
      height: '28px',
    },
    [up('lg')]: {
      width: '95px',
      height: '30px',
    },
    [up('xl')]: {
      width: '106px',
      height: '32px',
    },
    [up('xxl')]: {
      width: '109px',
      height: '40px',
    },
  },
  [`& .${classes.MonthSelectDropdownButtonMenu}`]: {
    '& .MuiPaper-root': {
      minWidth: 180,
    },
  },
  [`& .${classes.SearchField}`]: {
    '& fieldset': {
      border: 'none',
      borderRadius: '5px',
      backgroundColor: theme.palette.secondaryWhite.semiDark,
    },
    '& .MuiInputBase-input:hover + fieldset': {
      border: 'none !important',
    },
    '& .MuiInputBase-input:focus + fieldset': {
      border: 'none !important',
    },
    '& .MuiButtonBase-root': {
      padding: '4px',
    },
    '& .MuiInputBase-root': {
      padding: '0px !important',
      height: '32px',
      [up('xs')]: {
        width: '140px',
      },
      [up('md')]: {
        width: '220px',
      },
    },
  },
  [`& .${classes.externalHeaderAppBar}`]: {
    background: theme.palette.japanBlush.main,
    boxShadow: 'none',
    borderRadius: '5px',
    height: '48px',
    '& .MuiToolbar-root': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '8px 16px',
    },
  },
  [`& .${classes.externalHeaderAppBarTransaction}`]: {
    background: theme.palette.japanBlush.main,
    boxShadow: 'none',
    borderRadius: '5px',
    '& .css-10ltm04-MuiToolbar-root': {
      [up('xs')]: {
        padding: '0px 10px 0px 24px',
      },
      [up('sm')]: {
        padding: '0px 10px 0px 24px',
      },
      [up('md')]: {
        padding: '0px 10px 0px 24px',
      },
      [up('lg')]: {
        padding: '8px 10px 8px 24px',
      },
      [up('xl')]: {
        padding: '10px 10px 10px 24px',
      },
      [up('xxl')]: {
        padding: '11px 10px 11px 24px',
      },
    },
  },
  [`& .${classes.FilterBySelectDropdownButton}`]: {
    background: theme.palette.secondaryWhite.semiDark,
    color: theme.palette.darkPurple.darker,
    ':hover': {
      background: theme.palette.secondaryWhite.semiDark,
      color: theme.palette.darkPurple.darker,
    },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [up('xs')]: {
      width: '110px',
      height: '20px',
    },
    [up('sm')]: {
      width: '105px',
      height: '25px',
    },
    [up('md')]: {
      width: '105px',
      height: '28px',
    },
    [up('lg')]: {
      width: '110px',
      height: '30px',
    },
    [up('xl')]: {
      width: '127px',
      height: '32px',
    },
    [up('xxl')]: {
      width: '170px',
      height: '40px',
    },
  },
  [`& .${classes.documentRowMainBox}`]: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.documentNameBox}`]: {
    width: '100%',
  },
  [`& .${classes.gridBox}`]: {
    paddingTop: theme.spacing(1),
    height: 'calc(100% - 40px - 8px)',
  },
  [`& .${classes.gridBoxTransactions}`]: {
    // paddingTop: theme.spacing(1),
    height: '100%',
  },
  [`& .${classes.selectOptionsMainBox}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  [`& .${classes.selectOptionsMainBoxSecond}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  [`& .${classes.SelectedOptionsInnerBox}`]: {
    margin: '8px 0px',
    p: 1,
    display: 'flex',
    background: 'background.paper',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.5)',
  },
  [`& .${classes.editIcon}`]: {
    cursor: 'pointer',
    [up('xs')]: {
      width: '12',
      height: '12px',
    },
    [up('sm')]: {
      width: '14',
      height: '14px',
    },
    [up('md')]: {
      width: '16',
      height: '16px',
    },
    [up('lg')]: {
      width: '18',
      height: '18px',
    },
    [up('xl')]: {
      width: '20',
      height: '20px',
    },
    [up('xxl')]: {
      width: '22',
      height: '22px',
    },
  },
  [`& .${classes.StatusIcon}`]: {
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.StatusIconSize}`]: {
    [up('xs')]: {
      width: '14',
      height: '14px',
    },
    [up('sm')]: {
      width: '16',
      height: '16px',
    },
    [up('md')]: {
      width: '18',
      height: '18px',
    },
    [up('lg')]: {
      width: '20',
      height: '20px',
    },
    [up('xl')]: {
      width: '22',
      height: '22px',
    },
    [up('xxl')]: {
      width: '24',
      height: '24px',
    },
  },
  [`& .${classes.TagChip}`]: {
    border: 'none',
    color: theme.palette.darkPurple.main,
    background: theme.palette.japanBlush.main,
    cursor: 'pointer',
  },
  [`& .${classes.actionIcons}`]: {
    marginRight: '1vw',
    cursor: 'pointer',
    [up('xs')]: {
      width: '12',
      height: '12px',
    },
    [up('sm')]: {
      width: '14',
      height: '14px',
    },
    [up('md')]: {
      width: '16',
      height: '16px',
    },
    [up('lg')]: {
      width: '18',
      height: '18px',
    },
    [up('xl')]: {
      width: '20',
      height: '20px',
    },
    [up('xxl')]: {
      width: '22',
      height: '22px',
    },
  },
  [`& .${classes.moreVertIconBadge}`]: {
    '& .MuiBadge-badge': {
      left: -5,
      top: 3,
      backgroundColor: theme.palette.colorRed.main,
      cursor: 'pointer',
    },
  },
  [`& .${classes.responsiveHeaderBox}`]: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  [`& .${classes.selectedDocumentBox}`]: {
    height: '32px',
    padding: '4px 8px',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '5px',
    backgroundColor: theme.palette.secondaryWhite.main,
    color: theme.palette.secondaryBlack.main,
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.5)',
  },
  [`& .${classes.documentSelectedTypo}`]: {
    marginRight: '1vw',
  },
  [`& .${classes.documentRowTypography}`]: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  [`& .${classes.editIconBox}`]: {
    marginTop: '9px',
  },
  [`& .${classes.documentRowTypographyColor}`]: {
    color: theme.palette.lunarBase.main,
  },
  [`& .${classes.documentEditCellBox}`]: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.editCellTextfield}`]: {
    '& fieldset': {
      border: 'none',
      borderRadius: '5px',
      backgroundColor: theme.palette.secondaryWhite.semiDark,
    },
    '& .MuiInputBase-input:hover + fieldset': {
      border: 'none !important',
    },
    '& .MuiInputBase-input:focus + fieldset': {
      border: 'none !important',
    },
  },
  [`& .${classes.editCellActionIcons}`]: {
    padding: '0px, 10px',
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.failedChipColor}`]: {
    background: theme.palette.colorRed.main,
  },
  [`& .${classes.completedChipColor}`]: {
    background: theme.palette.colorGreen.main,
  },
  [`& .${classes.inProgressChipColor}`]: {
    background: theme.palette.lavender.main,
  },
  [`& .${classes.pendingChipColor}`]: {
    background: theme.palette.venetianRed.main,
  },
  [`& .${classes.tagChip}`]: {
    border: 'none',
    color: theme.palette.lunarBase.main,
    cursor: 'pointer',
  },
  [`& .${classes.dateValueBox}`]: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  [`& .${classes.actionBox}`]: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '9px',
  },
  [`& .${classes.selectedVersionBox}`]: {
    margin: '15px 10px',
    padding: 1,
    display: 'flex',
  },
  [`& .${classes.loaderBox}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [up('xs')]: {
      height: '40vh',
    },
    [up('sm')]: {
      height: '46vh',
    },
    [up('md')]: {
      height: '44vh',
    },
    [up('lg')]: {
      height: '40vh',
    },
    [up('xl')]: {
      height: '58vh',
    },
    [up('xxl')]: {
      height: '66vh',
    },
  },
  [`& .${classes.justifyContentFlexEnd}`]: {
    justifyContent: 'flex-end',
  },
  [`& .${classes.menuIconColor}`]: {
    color: theme.palette.darkPurple.main,
    cursor: 'pointer',
  },
  [`& .${classes.allReadButton}`]: {
    margin: '0 10px',
    [up('xs')]: {
      width: '100px',
      height: '25px',
    },
    [up('sm')]: {
      width: '120px',
      height: '28px',
    },
    [up('md')]: {
      width: '120px',
      height: '30px',
    },
    [up('lg')]: {
      width: '120px',
      height: '33px',
    },
    [up('xl')]: {
      width: '140px',
      height: '35px',
    },
    [up('xxl')]: {
      width: '170px',
      height: '45px',
    },
  },
  [`& .${classes.customFilterButtonBox}`]: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  [`& .${classes.customFilterMainBox}`]: {
    padding: theme.spacing(1),
  },
  [`& .${classes.customFilterButtonClass}`]: {
    margin: theme.spacing(1),
    padding: theme.spacing(0.5),
  },
  [`& .${classes.resetButtons}`]: {
    padding: theme.spacing(0.5),
    [up('xs')]: {
      fontSize: '6px',
    },
    [up('sm')]: {
      fontSize: '7px',
      marginLeft: theme.spacing(0.5),
    },
    [up('md')]: {
      fontSize: '8px',
      marginLeft: theme.spacing(1),
    },
    [up('lg')]: {
      fontSize: '9px',
    },
    [up('xl')]: {
      fontSize: '10px',
    },
    [up('xxl')]: {
      fontSize: '11px',
    },
  },
  [`& .${classes.accuracySelectionDropdown}`]: {
    marginLeft: '1vw',
    width: '8vw',
    [up('sm')]: {
      height: '5vh',
      width: '22vw',
    },
    [up('md')]: {
      height: '5vh',
      width: '15vw',
    },
    [up('lg')]: {
      height: '6vh',
      width: '11vw',
    },
    [up('xl')]: {
      height: '4vh',
    },
    [up('xxl')]: {
      height: '5vh',
    },
  },
}));
